/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LookupValue
 */
export interface LookupValue {
    /**
     * 
     * @type {string}
     * @memberof LookupValue
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupValue
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof LookupValue
     */
    value?: string;
}

/**
 * Check if a given object implements the LookupValue interface.
 */
export function instanceOfLookupValue(value: object): value is LookupValue {
    return true;
}

export function LookupValueFromJSON(json: any): LookupValue {
    return LookupValueFromJSONTyped(json, false);
}

export function LookupValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LookupValue {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'label': json['label'] == null ? undefined : json['label'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function LookupValueToJSON(json: any): LookupValue {
    return LookupValueToJSONTyped(json, false);
}

export function LookupValueToJSONTyped(value?: LookupValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'label': value['label'],
        'value': value['value'],
    };
}

